import dayjs from "dayjs";
import TopBarMenu from "@/constants/desktopTopBar.json";
import siteInfo from "@/constants/siteInfo";
import SVG from "react-inlinesvg";
import { useAuth } from "@/context/AuthContext";
import { getDashboardUrl } from "@/utils/sso";
import { useContext, useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { MasterConfigContext } from "@/context/MasterConfigContext";

const TopBar = ({
  isRajasthan = false,
  isMadhya = false,
  isHR = false,
  isUP = false,
  isBH = false,
  isCGH = false,
  isBiz=false
}) => {
  const { user, logout, login, isAuthenticated, loading } = useAuth();
  const masterConfig = useContext(MasterConfigContext);
  const ssoKeys = masterConfig["SSO"];
  const [showOptn, setShowOptn] = useState(false);
   
  const ref = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowOptn(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // State for current date and time
  const [currentDateTime, setCurrentDateTime] = useState(false);
  const intervalRef = useRef(null);

useEffect(() => {
  let current;

  const updateUI = () => {
    setCurrentDateTime({
      date: current.format("MMMM DD, YYYY"),
      time: current.format("HH:mm [IST]"),
    });
  };

  const startInterval = () => {
    updateUI();

    intervalRef.current = setInterval(() => {
      current = current.add(1, "minute");
      updateUI();
    }, 60000);
  };

  const fetchTime = async () => {
      try {
        // Primary API
        const res = await fetch("https://feeds.intoday.in/geocheck");
        if (!res.ok) {
          throw new Error("Primary API failed");
        }

        const data = await res?.json();

        if (!data?.timestamp) {
          throw new Error("Primary API returned no timestamp");
        }

        current = dayjs(Number(data.timestamp) * 1000);

        startInterval();

      } catch (err) {
        console.error("Primary time API failed:", err);

        try {

          const fallbackRes = await fetch("/api/time", {
            cache: "no-store",
          });

          if (!fallbackRes.ok) {
            throw new Error("Fallback API failed");
          }

          const fallbackData = await fallbackRes.json();

          current = dayjs(fallbackData?.timestamp);

          startInterval();

        } catch (fallbackErr) {
          console.error("Fallback time API failed:", fallbackErr);
        }
      }
    };

  fetchTime();

  return () => {
    if (intervalRef.current) {
      clearInterval(intervalRef?.current);
    }
  };
}, []);

  const router = useRouter();
  return (
    <div className="sticky top-0 flex justify-between items-center px-0 bg-[#F1F2F6] shadow-xs text-[13px] text-gray-500 overflow-hidden md:z-[600]">
      <div className="flex items-center flex-1 min-w-0">

      
      <div className="flex-1 min-w-0 overflow-auto no-scrollbar mr-2 md:mr-0 py-1 md:py-0 flex space-x-1 md:space-x-2">
          <div className="shrink-0 ml-2.5 md:ml-4 mr-2 md:mr-4">
            <a
              href={process.env.NEXT_PUBLIC_WEBSITE_URL}
              className="hover:text-primary font-semibold"
            >
              NewsTak
            </a>
          </div>
          {TopBarMenu?.map((item, index) => (
            <div key={index} className="pe-2 shrink-0">
              <a
                href={item?.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`${isRajasthan
                  ? "hover:text-rajasthanDark"
                  : isMadhya
                    ? "hover:text-mpDark"
                    : isHR
                      ? "hover:text-hrDark"
                      : isBH
                        ? "hover:text-biharDark"
                        : isUP
                          ? "hover:text-upDark"
                          : isCGH
                            ? "hover:text-mpDark"
                            : isBiz ? "hover:text-bizDark"
                            : "hover:text-primary"
                  }`}
              >
                {item?.name}
              </a>
            </div>
          ))}
        </div>
      </div>
      <div className="flex gap-2  -my-1">
      <div className="shrink-0 flex items-center justify-center md:justify-end space-x-1 ps-1 py-1 md:py-0 text-xs bg-[#E7E8EB] md:bg-inherit">
          <span
            className={`${isRajasthan
              ? "text-rajasthanDark"
              : isMadhya
                ? "text-mpDark"
                : isHR
                  ? "text-hrDark"
                  : isBH
                    ? "text-biharDark"
                    : isUP
                      ? "text-upDark"
                      : isCGH
                        ? " text-mpDark"
                        : isBiz ? " text-bizDark"  
                        : "text-primary"
              }`}
          >
            {/* <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/calender.svg" /> */}
         <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none"><path d="M5.66699 1.49268V3.61768" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.333 1.49268V3.61768" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.47949 6.51465H14.5212" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.875 6.09684V12.1177C14.875 14.2427 13.8125 15.6593 11.3333 15.6593H5.66667C3.1875 15.6593 2.125 14.2427 2.125 12.1177V6.09684C2.125 3.97184 3.1875 2.55518 5.66667 2.55518H11.3333C13.8125 2.55518 14.875 3.97184 14.875 6.09684Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.49676 9.78019H8.50312" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.87469 9.78019H5.88105" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.87469 11.9052H5.88105" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </span>
         {currentDateTime?.date ? (
          <span className="px-1 whitespace-nowrap">
            {currentDateTime.date} | {currentDateTime.time}
          </span>
          ) : (
            <span className="px-1 inline-block w-36 h-3 rounded bg-gray-300 animate-pulse" />
          )}
          <div className="hidden md:flex items-center space-x-1">

            <span className="-ml-2 px-1">|</span>
            <span className="px-1 line-clamp-1"> Follow us at: </span>

            <span
              className={`${isRajasthan
                ? "text-rajasthanDark"
                : isMadhya
                  ? "text-mpDark"
                  : isHR
                    ? "text-hrDark"
                    : isBH
                      ? "text-biharDark"
                      : isUP
                        ? "text-upDark"
                        : isCGH
                          ? " text-mpDark"
                          : isBiz ? " text-bizDark"
                          : "text-primary"
                } px-1 text-center`}
            >
              <a
                className="inline"
                target="_blank"
                href={siteInfo?.socialLinks?.twitter}
              >
                {/* <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/twitterSquare.svg" /> */}
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="15px" height="15px" loading="eager"><path d="M26.37,26l-8.795-12.822l0.015,0.012L25.52,4h-2.65l-6.46,7.48L11.28,4H4.33l8.211,11.971L12.54,15.97L3.88,26h2.65 l7.182-8.322L19.42,26H26.37z M10.23,6l12.34,18h-2.1L8.12,6H10.23z"></path></svg>

              </a>
            </span>

            <span
              className={`${isRajasthan
                ? "text-rajasthanDark"
                : isMadhya
                  ? "text-mpDark"
                  : isHR
                    ? "text-hrDark"
                    : isBH
                      ? "text-biharDark"
                      : isUP
                        ? "text-upDark"
                        : isCGH
                          ? " text-mpDark"
                          : isBiz ? " text-bizDark"
                          : "text-primary"
                } px-1 text-center`}
            >
              <a
                className="inline"
                target="_blank"
                href={siteInfo?.socialLinks?.facebook}
              >
                {/* <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/facebookSquare.svg" /> */}
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 10 15" fill="none" loading="eager"><path d="M3.19904 14.7724L3.17857 8.47546H0.5V5.77677H3.17857V3.97765C3.17857 1.54955 4.67099 0.379395 6.82088 0.379395C7.85069 0.379395 8.73577 0.45664 8.9937 0.491165V3.02867L7.50264 3.02936C6.33342 3.02936 6.10703 3.58913 6.10703 4.41055V5.77677H9.42857L8.53571 8.47546H6.10702V14.7724H3.19904Z" fill="currentColor"></path></svg>

              </a>
            </span>
            <span
              className={`${isRajasthan
                ? "text-rajasthanDark"
                : isMadhya
                  ? "text-mpDark"
                  : isHR
                    ? "text-hrDark"
                    : isBH
                      ? "text-biharDark"
                      : isUP
                        ? "text-upDark"
                        : isCGH
                          ? " text-mpDark"
                          : isBiz ? " text-bizDark"
                          : "text-primary"
                } px-1 text-center`}
            >
              <a
                className="inline"
                target="_blank"
                href={siteInfo?.socialLinks?.instagram}
              >
                {/* <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/instagramSquare.svg" /> */}
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" loading="eager"><path d="M10.2966 4.01825C10.7274 4.01825 11.0766 3.66903 11.0766 3.23825C11.0766 2.80747 10.7274 2.45825 10.2966 2.45825C9.86582 2.45825 9.5166 2.80747 9.5166 3.23825C9.5166 3.66903 9.86582 4.01825 10.2966 4.01825Z" fill="currentColor"></path><path fillRule="evenodd" clipRule="evenodd" d="M3.67871 6.57593C3.67871 8.3683 5.13634 9.82593 6.92871 9.82593C8.72109 9.82593 10.1787 8.3683 10.1787 6.57593C10.1787 4.78355 8.72109 3.32593 6.92871 3.32593C5.13634 3.32593 3.67871 4.78355 3.67871 6.57593ZM5.30371 6.57593C5.30371 5.67974 6.03252 4.95093 6.92871 4.95093C7.8249 4.95093 8.55371 5.67974 8.55371 6.57593C8.55371 7.47212 7.8249 8.20093 6.92871 8.20093C6.03252 8.20093 5.30371 7.47212 5.30371 6.57593Z" fill="currentColor"></path><path fillRule="evenodd" clipRule="evenodd" d="M3.67871 13.0759H10.1787C11.8492 13.0759 13.4287 11.4964 13.4287 9.82593V3.32593C13.4287 1.65543 11.8492 0.0759277 10.1787 0.0759277H3.67871C2.00821 0.0759277 0.428711 1.65543 0.428711 3.32593V9.82593C0.428711 11.4964 2.00821 13.0759 3.67871 13.0759ZM2.05371 3.32593C2.05371 2.56624 2.91902 1.70093 3.67871 1.70093H10.1787C10.9384 1.70093 11.8037 2.56624 11.8037 3.32593V9.82593C11.8037 10.5856 10.9384 11.4509 10.1787 11.4509H3.67871C2.9044 11.4509 2.05371 10.6002 2.05371 9.82593V3.32593Z" fill="currentColor"></path></svg>

              </a>
            </span>
            <span
              className={`${isRajasthan
                ? "text-rajasthanDark"
                : isMadhya
                  ? "text-mpDark"
                  : isHR
                    ? "text-hrDark"
                    : isBH
                      ? "text-biharDark"
                      : isUP
                        ? "text-upDark"
                        : isCGH
                          ? " text-mpDark"
                          : isBiz ? " text-bizDark"
                          : "text-primary"
                } px-1 text-center`}
            >
              <a
                className="inline"
                target="_blank"
                href={siteInfo?.socialLinks?.youtube}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none" loading="eager"><path fillRule="evenodd" clipRule="evenodd" d="M14.6946 0.418996C15.3797 0.600341 15.9194 1.13181 16.1032 1.80538C16.4446 3.03475 16.4286 5.59791 16.4286 5.59791C16.4286 5.59791 16.4262 8.14694 16.0952 9.37552C15.909 10.0483 15.3669 10.579 14.6826 10.7596C13.4307 11.0814 8.42226 11.0759 8.42226 11.0759C8.42226 11.0759 3.42739 11.0704 2.16269 10.7329C1.47677 10.5515 0.937154 10.02 0.753284 9.34726C0.425516 8.13045 0.428712 5.56808 0.428712 5.56808C0.428712 5.56808 0.431911 3.01827 0.762077 1.78889C0.947546 1.11611 1.50235 0.572864 2.17388 0.39309C3.42659 0.0704384 8.43425 0.0759337 8.43425 0.0759337C8.43425 0.0759337 13.4427 0.081429 14.6946 0.418996ZM6.83618 3.22002L6.83218 7.93026L10.9988 5.57907L6.83618 3.22002Z" fill="currentColor"></path></svg>

                {/* <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/youtubeSquare.svg" /> */}
              </a>
            </span>
          <div className="shrink-0 h-9 flex items-center">
            {ssoKeys?.showSignInButton ?
              <>
                {loading ? (
                  <div className="w-25 h-9 bg-gray-300 animate-pulse" />
                ) : <>
                  <div className="ml-4  cursor-pointer font-semibold gap-1 px-2 py-1 bg-primary text-white  ">

                    {!isAuthenticated && (
                      <div onClick={login} className="flex items-center gap-2">
                        {" "}
                        <span>{"Sign In"}</span>
                        {/* <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/user_ico.svg" className="w-5 h-5" /> */}
                        <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5"><rect width="45" height="45" rx="22.5" fill="white"></rect><rect x="10" y="10" width="25" height="25" rx="12.5" fill="white"></rect><path d="M22.6249 23.3125C22.552 23.3021 22.4583 23.3021 22.3749 23.3125C20.5416 23.25 19.0833 21.75 19.0833 19.9063C19.0833 18.0208 20.6041 16.4896 22.4999 16.4896C24.3853 16.4896 25.9166 18.0208 25.9166 19.9063C25.9062 21.75 24.4583 23.25 22.6249 23.3125Z" stroke="black" stroke-width="1.5625" stroke-linecap="round" stroke-linejoin="round"></path><path d="M29.5209 30.1875C27.6667 31.8854 25.2084 32.9167 22.5001 32.9167C19.7917 32.9167 17.3334 31.8854 15.4792 30.1875C15.5834 29.2083 16.2084 28.25 17.323 27.5C20.1772 25.6042 24.8438 25.6042 27.6772 27.5C28.7917 28.25 29.4167 29.2083 29.5209 30.1875Z" stroke="black" stroke-width="1.5625" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22.4999 32.9167C28.2529 32.9167 32.9166 28.253 32.9166 22.5C32.9166 16.747 28.2529 12.0833 22.4999 12.0833C16.747 12.0833 12.0833 16.747 12.0833 22.5C12.0833 28.253 16.747 32.9167 22.4999 32.9167Z" stroke="black" stroke-width="1.5625" stroke-linecap="round" stroke-linejoin="round"></path></svg>

                      </div>
                    )}

                    {isAuthenticated && (
                      <div onMouseEnter={() => setShowOptn(true)}>
                        <div className="flex items-center gap-2 overflow-hidden">
                          <div className="overflow-x-auto no-scrollbar whitespace-nowrap max-w-[80px]">{user?.givenName || "Guest"}</div>
                          {user?.photo && <img
                            src={user?.photo || "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/authorDefault.png"}
                            alt="user"
                            fetchPriority="high"
                            loading="eager"
                            className="w-5 h-5 rounded-full shrink-0"
                          />}
                          {!user?.photo && <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/user_ico.svg" className="w-5 h-5 shrink-0" />}
                        </div>
                        {showOptn && (
                          <div
                            ref={ref}
                            onMouseLeave={() => setShowOptn(false)}
                            className="font-medium text-black text-[14px] z-50 fixed top-8 right-12 mr-4 w-[7.5rem] rounded-lg flex flex-col gap-2 px-4 bg-white border border-gray-200 transform translate-x-1/2 transition-opacity delay-300 shadow-md"
                          >
                            <a
                              href={getDashboardUrl(router?.asPath)}
                              className="border-b text-center p-2"
                              target="_blank"
                            >
                              My Profile
                            </a>
                            <span onClick={logout} className="text-center pb-2">Sign Out</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </>}
              </> : <></>}
          </div>
        </div>

        </div>
      </div>
    </div>
  );
};

export default TopBar;
